import "lib/moment-i18n";
import moment from "moment-timezone";

export enum PERIOD {
    DAILY = "daily",
    DATE = "on_date",
}
export enum RESERVE_AT {
    CART = "on_add_to_cart",
    SUBMISSION = "order_submission",
}

export interface ReservationSettings {
    expires: boolean;
    period?: PERIOD;
    date?: string;
    hour?: number;
    timezone?: string;
    alerts?: boolean;
    alertHours?: number;
}

export const DEFAULT_DAILY_HOUR = 0;
export const ALERT_HOURS_MIN = 1;
export const ALERT_HOURS_MAX_DAILY = 12;
export const ALERT_HOURS_MAX_DATE = 72;

export const DEFAULT_STATE = (selectedPeriod?: string): ReservationSettings => {
    const period = selectedPeriod === PERIOD.DATE ? PERIOD.DATE : PERIOD.DAILY;
    const timezone = moment.tz.guess();
    const defaultDate = moment.tz(timezone).startOf("day").hour(DEFAULT_DAILY_HOUR).utc();

    return {
        expires: false,
        period,
        date: period === PERIOD.DATE ? getNext(defaultDate).toISOString() : undefined,
        hour: period === PERIOD.DAILY ? defaultDate.hour() : undefined,
        timezone,
        alerts: false,
        alertHours: ALERT_HOURS_MIN,
    };
};

export const getNext = (date: moment.Moment) =>
    date.isAfter(moment.tz(date.tz())) ? date : moment.tz(date, date.tz()).add(1, "d");
